import { render, staticRenderFns } from "./2FA.vue?vue&type=template&id=c29f10b8&scoped=true"
import script from "./2FA.vue?vue&type=script&lang=js"
export * from "./2FA.vue?vue&type=script&lang=js"
import style0 from "./2FA.vue?vue&type=style&index=0&id=c29f10b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29f10b8",
  null
  
)

export default component.exports